import { render, staticRenderFns } from "./CompanyProfileLayout.vue?vue&type=template&id=2f557cbc"
import script from "./CompanyProfileLayout.vue?vue&type=script&lang=js"
export * from "./CompanyProfileLayout.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileLayout.vue?vue&type=style&index=0&id=2f557cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports